import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLang } from "../lib/lang";
import { Shield, Target, Users } from "lucide-react";

export default function AboutPage() {
  const { t } = useLang();
  const values = [
    { icon: Shield, title: "Defense", desc: "Protecting the people and homeland of Kawthoolei." },
    { icon: Target, title: "Discipline", desc: "Acting under codes of conduct rooted in international humanitarian law." },
    { icon: Users, title: "Service", desc: "Serving alongside civilian institutions and humanitarian partners." },
  ];
  return (
    <div className="App" data-testid="about-page">
      <Header />
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="border-b border-slate-200 pb-6 mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-red-600 font-semibold mb-2">Institution</div>
          <h1 className="font-display text-5xl sm:text-6xl text-slate-900">{t("about_title")}</h1>
        </div>
        <p className="text-xl text-slate-700 leading-relaxed mb-6" data-testid="about-p1">{t("about_p1")}</p>
        <p className="text-base text-slate-600 leading-relaxed mb-12" data-testid="about-p2">{t("about_p2")}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <div key={i} className="border border-slate-200 p-6" data-testid={`value-${i}`}>
              <div className="w-12 h-12 bg-slate-900 text-white flex items-center justify-center mb-4">
                <v.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <div className="font-display text-2xl text-slate-900 mb-2">{v.title}</div>
              <p className="text-sm text-slate-600">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
